import React from "react";
import { withRouter } from "react-router-dom";

const styles = {
    wrapper: { margin: "0 auto", width: "100%" },
    select: {
        width: "100%",
        padding: "16px 14px",
        borderRadius: "4px",
        backgroundColor: "#fff",
        fontSize: "16px",
    },
};

const SelectCampania = ({ campanias, history, hash }) => {


    function handleSelect(e) {
        const hash = e.target.value;
        history.push(`?hash=${hash}`);
    }

    return (
        <div style={styles.wrapper}>
            <label style={{ fontSize: "16px" }}>Campaña</label>
            <select
                onChange={handleSelect}
                style={styles.select}
                name=""
                id=""
                defaultValue={hash}
            >
                <option value="">-- Seleccione una Campaña --</option>
                {campanias.length &&
                    campanias.map((camp) => (
                        <option key={camp.hash} value={camp.hash}>
                            {camp.nombre}
                        </option>
                    ))}
            </select>
        </div>
    );
};

export default withRouter(SelectCampania);



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/SelectCampania.js